<script lang="ts">
    import SocialIcon from './SocialIcon.svelte';

    interface Props {
        mode?: 'signin' | 'signup';
    }

    let { mode = 'signin' }: Props = $props();

    const label = $derived(mode === 'signin' ? 'Sign in' : 'Sign up');
</script>

<div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
    <a
        href="/auth/google/redirect"
        class="flex items-center justify-center gap-2 rounded-md border border-gray-700 bg-gray-800 px-4 py-2.5 text-sm font-medium text-gray-300 shadow-sm transition-all hover:bg-gray-700 hover:shadow focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-1"
    >
        <SocialIcon provider="google" colored class="size-5" />
        <span class="sm:hidden">{label} with Google</span>
        <span class="hidden sm:inline">Google</span>
    </a>

    <a
        href="/auth/apple/redirect"
        class="flex items-center justify-center gap-2 rounded-md border border-gray-700 bg-gray-800 px-4 py-2.5 text-sm font-medium text-gray-300 shadow-sm transition-all hover:bg-gray-700 hover:shadow focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-1"
    >
        <SocialIcon provider="apple" class="size-5" />
        <span class="sm:hidden">{label} with Apple</span>
        <span class="hidden sm:inline">Apple</span>
    </a>

    <a
        href="/auth/orcid/redirect"
        class="flex items-center justify-center gap-2 rounded-md border border-gray-700 bg-gray-800 px-4 py-2.5 text-sm font-medium text-gray-300 shadow-sm transition-all hover:bg-gray-700 hover:shadow focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-1"
    >
        <SocialIcon provider="orcid" colored class="size-5" />
        <span class="sm:hidden">{label} with ORCiD</span>
        <span class="hidden sm:inline">ORCiD</span>
    </a>
</div>

<div class="relative mb-6">
    <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-700"></div>
    </div>
    <div class="relative flex justify-center text-sm">
        <span class="bg-gray-900 px-3 text-gray-500">or</span>
    </div>
</div>
